import React from 'react';
import styled from 'styled-components';

const StatusContainerTag = styled.div`
  background: #f0f0f6;
  text-transform: uppercase;
  border-radius: 4px;
  padding: 0px 8px;
  font-size: 1.2rem;
  font-weight: 700;
  color: #00000099;
  margin-left: 2rem;
  height: 2rem;
`;

const StatusHolder = (props) => {
  return <StatusContainerTag>{props.children}</StatusContainerTag>;
};

export default StatusHolder;
